import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { PAGE_URL, remove } from '@/api/system/mail-recipient';
import { createFormItem } from '@/component-create/utils/create-form-item';
import { createTableColumn, tableAddHeader, tableDeleteController, tableDeleteHeader, tableEditController, tableEditHeader } from '@/component-create/utils/create-table-column';
import { useCommonDialog } from '@/component-create/utils/hooks';
import { FORM_ITEM } from '@/components/form/enums';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { renderContactAddForm } from './contact-add';
import { renderContactEditForm } from './contact-edit';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Contact',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var searchForm = ref();
    var tableRef = ref();
    var addFormRef = ref();
    var editFormRef = ref();
    var addForm;
    var editForm;
    var searchData = {};
    var dialog = useCommonDialog('contactDialog');
    onMounted(function () {
      addForm = renderContactAddForm(addFormRef.value);
      addForm.onSaveSuccess = function () {
        var _tableRef$value;
        (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.load(searchData);
      };
      editForm = renderContactEditForm(editFormRef.value);
      editForm.onSaveSuccess = function () {
        var _tableRef$value2;
        (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.load(searchData);
      };
    });
    var items = [createFormItem('联系人名称', 'recipientName', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('邮箱地址', 'mailAddress', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    })];
    var column = [createTableColumn('联系人名称', 'recipientName'), createTableColumn('邮箱地址', 'mailAddress', '280', undefined, {
      showOverflowTooltip: true
    }), createTableColumn('备注', 'remark', undefined, undefined, {
      showOverflowTooltip: true
    }), createTableColumn('创建时间', 'createdAt', '150', 'center'), createTableColumn('操作', undefined, '200', 'center', {
      controller: [tableEditController(function (row) {
        editForm.open(row.id);
      }), tableDeleteController(function (row) {
        deleteBox().then(function () {
          remove([row.id]).then(function () {
            var _tableRef$value3;
            toast.success('删除成功');
            (_tableRef$value3 = tableRef.value) === null || _tableRef$value3 === void 0 || _tableRef$value3.load(searchData);
          });
        });
      })]
    })];
    var headerButton = [tableAddHeader(function () {
      addForm.open();
    }), tableEditHeader(function (rows) {
      if (isOnlyOne(rows)) {
        editForm.open(rows[0].id);
      }
    }), tableDeleteHeader(function (rows) {
      if (rows.length === 0) {
        toast.warn('请至少选择一条数据');
      } else {
        deleteBox().then(function () {
          remove(rows.map(function (i) {
            return i.id;
          })).then(function () {
            var _tableRef$value4;
            toast.success('删除成功');
            (_tableRef$value4 = tableRef.value) === null || _tableRef$value4 === void 0 || _tableRef$value4.load(searchData);
          });
        });
      }
    })];
    function open() {
      dialog.open();
    }
    function reset() {
      var _tableRef$value5;
      searchData = {};
      (_tableRef$value5 = tableRef.value) === null || _tableRef$value5 === void 0 || _tableRef$value5.load({});
    }
    function search(data) {
      var _tableRef$value6;
      searchData = data;
      (_tableRef$value6 = tableRef.value) === null || _tableRef$value6 === void 0 || _tableRef$value6.load(data);
    }
    __expose({
      open: open
    });
    return function (_ctx, _cache) {
      var _component_XSearchForm = _resolveComponent("XSearchForm");
      var _component_XTable = _resolveComponent("XTable");
      var _component_XCommonDialog = _resolveComponent("XCommonDialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_XCommonDialog, {
        ref: "contactDialog",
        title: "联系人管理",
        width: "70%"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_XSearchForm, {
            ref_key: "searchForm",
            ref: searchForm,
            items: items,
            onSearch: search,
            onReset: reset
          }, null, 512), _createVNode(_component_XTable, {
            ref_key: "tableRef",
            ref: tableRef,
            url: _unref(PAGE_URL),
            "show-index": "",
            selectable: "",
            column: column,
            "header-buttons": headerButton,
            "el-table-props": {
              border: true
            }
          }, null, 8, ["url"])];
        }),
        _: 1
      }, 512), _createElementVNode("div", {
        ref_key: "addFormRef",
        ref: addFormRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editFormRef",
        ref: editFormRef
      }, null, 512)]);
    };
  }
});